import capitalize from 'lodash/capitalize';
import { CAT_IDS_BY_TYPES, CAT_TYPES } from '../constants';

const MOVING_TYPES_IDS = CAT_IDS_BY_TYPES[CAT_TYPES.MOVING_TYPE];

export const mergeMovingTypes = (names: string[]) => {
  return names.reduce((acc, name, index) => {
    if (index === 0) {
      return `${capitalize(name)}`;
    }

    if (index === names.length - 1) {
      return `${acc} и ${name.toLowerCase()}`;
    }

    return `${acc}, ${name.toLowerCase()}`;
  }, '');
};

const combineMovingTypes = (
  categories: {
    id: number;
    name: string;
  }[]
): string | null => {
  if (!categories) {
    return null;
  }

  const movingTypes = categories.filter((category) => MOVING_TYPES_IDS.includes(category.id));

  return mergeMovingTypes(movingTypes.map(({ name }) => name));
};

export default combineMovingTypes;
